// Small, always-needed bits of this page (path, title, dates), kept apart from the
// page text so the main app bundle does not have to carry the whole page.
import { PAGE_IMAGES } from './pageImages';

export const MEET_AGAIN_PATH = '/meet-again';

export const MEET_AGAIN_META = {
  title: 'Meet Again: Talk to the Same Person Again | Zuzu Club',
  description: 'Had a good chat on Zuzu? If you both tap Meet Again, Zuzu lets you know when you are both here. No accounts, no numbers, and only you two decide.',
  image: PAGE_IMAGES[MEET_AGAIN_PATH].image,
  alt: PAGE_IMAGES[MEET_AGAIN_PATH].alt,
};
